import { HashRouter } from "react-router-dom";
import { AppRouter } from "./components/router/AppRouter";

function App() {
  return (
    <HashRouter>
      <AppRouter />
    </HashRouter>
  );
}

export default App;
